// TODO: look into packages and refactor the component

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import {
  get
} from "lodash";

import Box from "@material-ui/core/Box";
import MDCRow from "./MDCRow";
import { fetchPost } from "../../../api/fetch";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow'
import moment from 'moment'
import Loader from "./../../Common/Loader";
import { getLov } from "./../../../utils/lov";
import { ATTRIBUTE } from "../../../constants/attributes";

// TODD filtes
/* const columns = [
  {
    name: "ref",
    minWidth: 108,
    width: 130,
  },
  {
    name: "activity",
    minWidth: 141,
    width: 300,
  },
  {
    name: "status",
    minWidth: 142,
    width: 300,
  },
  {
    name: "duration",
    minWidth: 102,
    width: 200,
  },
  {
    name: "po",
    minWidth: 132,
    width: 132,
  },
  {
    name: "carrier",
    minWidth: 133,
    width: 133,
  },
  {
    name: "assigned_driver",
    minWidth: 165,
    width: 165,
  },
  {
    name: "assigned_vehicle",
    minWidth: 133,
    width: 133,
  },
  {
    name: "trailer",
    minWidth: 133,
    width: 133,
  },
  {
    name: "zone_door",
    minWidth: 132,
    width: 132,
  }
]; */

const styles = {
  mainContent: {
    maxHeight: "100%",
    overflow: "auto",
    maxWidth: "1500px",
    paddingBottom: '15px',
  },
  tableHeader: {
    minWidth: '150px',
    textAlign: 'center',
    backgroundColor: '#E5F4F6',
    border: '2px solid #FFF',
    fontWeight: 'bold'
  }
};

const MDCTable = (props) => {
  //TODO: history, profiles, searchValue, language, onRedirect props
  const { classes, filters2, language } = props;
  const [lov, setLov] = useState();
  const [rows, setRows] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  // TODO: table filter
  /* const [filters, setFilters] = useState({
    ref: [],
    activity: [],
    status: [],
    duration: [],
    po: [],
    carrier: [],
    assigned_driver: [],
    assigned_vehicle: [],
    trailer: [],
    zone_door: []
  }); */

  useEffect(() => {
    const fetchLov = async () => {
      setLov({
        89: await getLov(ATTRIBUTE.CARRIER_NAME),
        108: await getLov(ATTRIBUTE.IS_LOADED),
      });
    };

    const fetchData = async () => {
      setIsFetching(true)

      var startDate = get(filters2, ["startDate"]).getTime();
      var calendarViews = get(filters2, ["calendarView"]);

      startDate = new Date(startDate).setHours(0, 0, 0, 0)

      const data = await fetchPost("schedules/occurrences", {
        action: "read",
        filter: {
          sites: [get(filters2, ["site"])],
          begin: startDate - 3600000,
          end:
            calendarViews === "day"
              ? startDate + 86400000
              : startDate + 604800000,
        },
      });

      setRows(sortSchedulesByDate(data));
      setIsFetching(false);
      // console.log('fetch schedule ==>', data);
    }
    fetchData();
    fetchLov();
  }, [filters2]);

  const sortSchedulesByDate = ((schedules) => {
    const sortedSchedules = schedules.sort((a, b) => new moment(a.occurrences[0].when).format('YYYYMMDD') - new moment(b.occurrences[0].when).format('YYYYMMDD'))
    return sortedSchedules;
  })

  return (
    <>
      {isFetching ? <Loader noDecoration /> :
        <Box className={classes.mainContent}>
          <Table aria-label="collapsible table" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeader}>{I18n.get('site_ref')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('activity')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('status')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('site_duration').replace(':', '')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('allowed_time_before')}/{I18n.get('allowed_time_after')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('site_po')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('carrier')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('assigned_driver')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('assigned_vehicle')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('site_trailer')}/{I18n.get('site_container')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('zone_door')}</TableCell>
                <TableCell className={classes.tableHeader}>{I18n.get('site_comment')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <MDCRow key={row.id} row={row} lov={lov} language={language} />
              ))}
            </TableBody>
          </Table>
        </Box>
      }
    </>
  )
};


const mapStateToProps = (state) => {
  return {
    language: state.user.language,
    profiles: state.profiles,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(MDCTable));